import { TemplateTabs } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog';
import { useTableLayoutTemplateContext } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/context';
import { stringIncludes } from '@aibees/shared/utils';
import { useMemo } from 'react';

export function useShowDefaultTemplateItem() {
  const { tab, searchValue } = useTableLayoutTemplateContext();

  return useMemo(() => {
    if (tab !== TemplateTabs.ALL) return false;
    return searchValue.length
      ? stringIncludes('Default', searchValue) // TODO write it better
      : true;
  }, [tab, searchValue]);
}
